(function ($) {

  //Wenn zu einem Target gescrollt werden soll, dann befindet sich ein entsprechender Parameter in der URL
  var url = new URL(window.location);
  var searchParams = url.searchParams;

  console.log(url, searchParams, searchParams.get('data-scrollto'));

  if(searchParams.get('data-scrollto') !== null) {
    //URL enthält Scrollto-Parameter
    $('html, body').animate({scrollTop: ($("#" + searchParams.get('data-target')).offset().top - 120)}, 'slow');
  }

})(window.jQuery);
